export const ID_TYPE = [
  {
    value: 'DRIVERSLICENSE',
    label: 'US Driver’s License',
  },
  {
    value: 'IDCARD',
    label: 'US State ID',
  },
  {
    value: 'PASSPORT',
    label: 'US Passport',
  },
  {
    value: 'PERMANENTRESIDENT',
    label: 'US Permanent Resident',
  },
];
